import React,{ Component } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { signOut } from '../actions'
import Menu from '../components/user_menu'
class ListaDirecciones extends Component{
	
	constructor(props) {
    	super(props);
    	this.state = {
        	loading : false
    	}
    }

  componentDidMount(){
    if(!this.props.usuario.user){
      this.props.history.push("/login")
    }
  }

  componentDidUpdate(prevProps, prevState){

  }

	render() {  

		if(this.state.loading){
			return <div>CARGANDO</div>
		}

    const  listaDirecciones = this.props.usuario.direcciones.map((direccion,i)=>{
      var data = Object.assign({},direccion);
      return (
        <tr>
          <td>{direccion.nombre }</td>
          <td>{direccion.calle + " " +direccion.altura + " " +direccion.ciudad + " " +direccion.provincia + " " +direccion.pais}</td>
          <td>{direccion.cont_apellido + " " +direccion.cont_nombre}</td>
        </tr>
      )
    })

    return (
      <section className="row mb-5 sombraHead mt-3 clearfix" >
        <div className="col-md-4 mb-3">
          <Menu salirAct={this.props.signOut}/>
        </div>
        <div className="col-md-6 mb-3">
          <div>
            <h1 className="display-4">Direcciones</h1>
            <Link to={'/usuario/direccion'} >Agregar</Link>
          </div>
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Nombre</th>
                <th scope="col">Direccion</th>
                <th scope="col">Contacto</th>
              </tr>
            </thead>
            <tbody>
              { listaDirecciones }
            </tbody>
          </table>
        </div>
      </section>
    )
  }
}

const mapStateToProps = state => {
	return {
    	usuario: state.usuario
  	}
}

const mapDispatchToProps = dispatch => {
  return {
    signOut: () => {
      dispatch(signOut())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ListaDirecciones)




// WEBPACK FOOTER //
// ./src/containers/lista_direcciones.js